import React, { useState } from 'react';
import { TextField, Button, Grid } from '@material-ui/core';
import Loader from 'react-loader-spinner';
import { FileUploader } from 'shared/FileUploader/FileUploader';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';
import handleNotification from 'helpers/handleNotification';
import { ITaxonomy } from 'api/services/taxonomies/types';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { taxonomyServices } from 'api/services';
import getImageByImageSize from 'helpers/getImageByImageSize';
import { IFile } from 'api/services/file/types';
import { useHistory } from 'react-router';

import './CreateTaxonomyPage.sass';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'store/store';
import { getTaxonomies } from 'store/ducks/taxonomies/actions';

export const CreateTaxonomyPage: React.FC = () => {
	const [name, setName] = useState('');
	const [title, setTitle] = useState('');
	const [file, setFile] = useState<IFile>();
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const { main, taxonomies } = useSelector(
		(state: AppState) => state.langReducer.i18n,
	);
	const history = useHistory();
	const dispatch = useDispatch();

	const createTaxonomy = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!name.trim() || !title.trim()) {
			setHasError(true);
			handleNotification(main.fillFields);
			return;
		}
		if (!file) {
			setHasError(true);
			handleNotification(main.selectImage);
			return;
		}
		setLoading(true);
		const data: ITaxonomy = {
			name,
			title,
			fileId: file.id,
		};

		try {
			await taxonomyServices.createTaxonomy(data);
			handleNotification(taxonomies.savedTaxonomy, 'success');
			history.push('/taxonomies');
			dispatch(getTaxonomies());
		} catch (e: any) {
			handleNotification(e?.response?.data?.message || main.tryAgain);
			setLoading(false);
		}
	};

	const selectFile = (file: IFile) => {
		setFile(file);
	};

	return (
		<MainTemplate title={taxonomies.createTaxonomy} hideBtn>
			<form onSubmit={createTaxonomy}>
				<TextField
					variant='outlined'
					label={main.title}
					required
					autoFocus
					className='form-field'
					value={title}
					error={hasError && !title.trim()}
					onChange={(e) => setTitle(e.target.value)}
				/>
				<TextField
					variant='outlined'
					label={main.name}
					className='form-field'
					value={name}
					required
					error={hasError && !name.trim()}
					onChange={(e) => setName(e.target.value)}
				/>
				{file && (
					<div className='page-form__file'>
						<img
							className='page-form__file-icon'
							src={getImageByImageSize({ file, imageSize: '100x100' })}
						/>
						<div className='page-form__file-delete'>
							<DeleteForeverIcon
								color='secondary'
								onClick={() => setFile(undefined)}
							/>
						</div>
					</div>
				)}
				<Grid
					container
					justifyContent='space-between'
					className='page-form__actions'>
					<FileUploader
						selectFile={selectFile}
						width={40}
						height={40}
						text={file ? main.changeIcon : main.selectIcon}
					/>
					<Button
						className='action-button'
						size='large'
						color='primary'
						type='submit'
						variant='contained'
						disabled={loading}>
						{loading ? (
							<Loader height={10} type='ThreeDots' color='#fff' />
						) : (
							main.create
						)}
					</Button>
				</Grid>
			</form>
		</MainTemplate>
	);
};
